import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';

export const scaffolderFr = createTranslationMessages({
  ref: scaffolderTranslationRef,
  full: true,
  messages: {
    'fields.entityNamePicker.title': 'Nom',
    'fields.entityNamePicker.description': 'Nom unique du composant',
    'fields.entityPicker.title': 'Entité',
    'fields.entityPicker.description': 'Une entité du catalogue',
    'fields.entityTagsPicker.title': 'Tags',
    'fields.entityTagsPicker.description':
      "Ajoutez les tags pertinents, appuyez sur « Entrée » pour ajouter de nouveaux tags. Format valide : [a-z0-9+#] séparés par [-], 63 caractères au maximum",
    'fields.multiEntityPicker.title': 'Entité',
    'fields.multiEntityPicker.description': 'Une entité du catalogue',
    'fields.myGroupsPicker.title': 'Entité',
    'fields.myGroupsPicker.description': 'Une entité du catalogue',
    'fields.ownedEntityPicker.title': 'Entité',
    'fields.ownedEntityPicker.description': 'Une entité du catalogue',
    'fields.ownerPicker.title': 'Propriétaire',
    'fields.ownerPicker.description': 'Le propriétaire du composant',
    'fields.azureRepoPicker.organization.title': 'Organisation',
    'fields.azureRepoPicker.organization.description':
      "L'organisation à laquelle ce dépôt appartiendra",
    'fields.azureRepoPicker.project.title': 'Projet',
    'fields.azureRepoPicker.project.description':
      'Le projet auquel ce dépôt appartiendra',
    'fields.bitbucketRepoPicker.project.title': 'Projets autorisés',
    'fields.bitbucketRepoPicker.project.description':
      'Le projet auquel ce dépôt appartiendra',
    'fields.bitbucketRepoPicker.project.inputTitle': 'Projets',
    'fields.bitbucketRepoPicker.workspaces.title': 'Espaces de travail autorisés',
    'fields.bitbucketRepoPicker.workspaces.description':
      "L'espace de travail auquel ce dépôt appartiendra",
    'fields.bitbucketRepoPicker.workspaces.inputTitle': 'Espaces de travail',
    'fields.gerritRepoPicker.parent.title': 'Parent',
    'fields.gerritRepoPicker.parent.description':
      'Le projet parent auquel le dépôt appartiendra',
    'fields.gerritRepoPicker.owner.title': 'Propriétaire',
    'fields.gerritRepoPicker.owner.description':
      'Le propriétaire du projet (facultatif)',
    'fields.giteaRepoPicker.owner.title': 'Propriétaires disponibles',
    'fields.giteaRepoPicker.owner.description':
      "Espace de noms Gitea auquel ce dépôt appartiendra. Il peut s'agir du nom d'une organisation, d'un groupe, d'un sous-groupe, d'un utilisateur ou du projet.",
    'fields.giteaRepoPicker.owner.inputTitle': 'Propriétaire',
    'fields.githubRepoPicker.owner.title': 'Propriétaires disponibles',
    'fields.githubRepoPicker.owner.description':
      "L'organisation, l'utilisateur ou le projet auquel ce dépôt appartiendra",
    'fields.githubRepoPicker.owner.inputTitle': 'Propriétaire',
    'fields.gitlabRepoPicker.owner.title': 'Propriétaires disponibles',
    'fields.gitlabRepoPicker.owner.description':
      "Espace de noms GitLab auquel ce dépôt appartiendra. Il peut s'agir du nom d'une organisation, d'un groupe, d'un sous-groupe, d'un utilisateur ou du projet.",
    'fields.gitlabRepoPicker.owner.inputTitle': 'Propriétaire',
    'fields.repoUrlPicker.host.title': 'Hôte',
    'fields.repoUrlPicker.host.description':
      "L'hôte sur lequel le dépôt sera créé",
    'fields.repoUrlPicker.repository.title': 'Dépôts disponibles',
    'fields.repoUrlPicker.repository.description': 'Le nom du dépôt',
    'fields.repoUrlPicker.repository.inputTitle': 'Dépôt',
    'fields.repoOwnerPicker.title': 'Propriétaire',
    'fields.repoOwnerPicker.description': 'Le propriétaire du dépôt',
    'aboutCard.launchTemplate': 'Lancer le modèle',
    'actionsPage.content.emptyState.title': 'Aucune information à afficher',
    'actionsPage.content.emptyState.description':
      "Aucune action n'est installée ou un problème de communication avec le backend est survenu.",
    'actionsPage.content.searchFieldPlaceholder': 'Rechercher une action',
    'actionsPage.title': 'Actions installées',
    'actionsPage.action.input': 'Entrée',
    'actionsPage.action.output': 'Sortie',
    'actionsPage.action.examples': 'Exemples',
    'actionsPage.subtitle':
      'Voici la collection de toutes les actions installées',
    'actionsPage.pageTitle': 'Créer un nouveau composant',
    'listTaskPage.content.emptyState.title': 'Aucune information à afficher',
    'listTaskPage.content.emptyState.description':
      "Il n'y a aucune tâche ou un problème de communication avec le backend est survenu.",
    'listTaskPage.content.tableCell.template': 'Modèle',
    'listTaskPage.content.tableCell.status': 'Statut',
    'listTaskPage.content.tableCell.owner': 'Propriétaire',
    'listTaskPage.content.tableCell.created': 'Créée le',
    'listTaskPage.content.tableCell.taskID': 'ID de tâche',
    'listTaskPage.content.tableTitle': 'Tâches',
    'listTaskPage.title': 'Liste des tâches de modèles',
    'listTaskPage.subtitle': 'Toutes les tâches qui ont été démarrées',
    'listTaskPage.pageTitle': 'Tâches des modèles',
    'ownerListPicker.title': 'Propriétaire de la tâche',
    'ownerListPicker.options.all': 'Toutes',
    'ownerListPicker.options.owned': 'Les miennes',
    'ongoingTask.title': 'Exécution de',
    'ongoingTask.contextMenu.cancel': 'Annuler',
    'ongoingTask.contextMenu.startOver': 'Recommencer',
    'ongoingTask.contextMenu.retry': 'Réessayer',
    'ongoingTask.contextMenu.hideLogs': 'Masquer les logs',
    'ongoingTask.contextMenu.showLogs': 'Afficher les logs',
    'ongoingTask.contextMenu.hideButtonBar': 'Masquer la barre de boutons',
    'ongoingTask.contextMenu.showButtonBar': 'Afficher la barre de boutons',
    'ongoingTask.contextMenu.moreOptions': "Plus d'options",
    'ongoingTask.subtitle': 'Tâche {{taskId}}',
    'ongoingTask.pageTitle.hasTemplateName': 'Exécution de {{templateName}}',
    'ongoingTask.pageTitle.noTemplateName': 'Exécution du Scaffolder',
    'ongoingTask.cancelButtonTitle': 'Annuler',
    'ongoingTask.retryButtonTitle': 'Réessayer',
    'ongoingTask.startOverButtonTitle': 'Recommencer',
    'ongoingTask.hideLogsButtonTitle': 'Masquer les logs',
    'ongoingTask.showLogsButtonTitle': 'Afficher les logs',
    'templateEditorForm.stepper.emptyText':
      "Il n'y a aucun paramètre de spécification à prévisualiser dans le modèle.",
    'renderSchema.undefined': 'Aucun schéma défini',
    'renderSchema.tableCell.name': 'Nom',
    'renderSchema.tableCell.type': 'Type',
    'renderSchema.tableCell.title': 'Titre',
    'renderSchema.tableCell.description': 'Description',
    'renderSchema.tableCell.value': 'Valeur',
    'templatingExtensions.content.values.title': 'Valeurs',
    'templatingExtensions.content.values.notAvailable':
      "Aucune valeur globale de modèle n'est définie.",
    'templatingExtensions.content.emptyState.title':
      'Aucune information à afficher',
    'templatingExtensions.content.emptyState.description':
      "Aucune extension de templating n'est disponible ou un problème de communication avec le backend est survenu.",
    'templatingExtensions.content.filters.title': 'Filtres',
    'templatingExtensions.content.filters.schema.input': 'Entrée',
    'templatingExtensions.content.filters.schema.output': 'Sortie',
    'templatingExtensions.content.filters.schema.arguments': 'Arguments',
    'templatingExtensions.content.filters.examples': 'Exemples',
    'templatingExtensions.content.filters.notAvailable':
      "Aucun filtre de modèle n'est défini.",
    'templatingExtensions.content.filters.metadataAbsent':
      'Métadonnées du filtre indisponibles',
    'templatingExtensions.content.searchFieldPlaceholder':
      'Rechercher une extension',
    'templatingExtensions.content.functions.title': 'Fonctions',
    'templatingExtensions.content.functions.schema.output': 'Sortie',
    'templatingExtensions.content.functions.schema.arguments': 'Arguments',
    'templatingExtensions.content.functions.examples': 'Exemples',
    'templatingExtensions.content.functions.notAvailable':
      "Aucune fonction globale de modèle n'est définie.",
    'templatingExtensions.content.functions.metadataAbsent':
      'Métadonnées de la fonction indisponibles',
    'templatingExtensions.title': 'Extensions de templating',
    'templatingExtensions.subtitle':
      'Voici la collection des extensions de templating disponibles',
    'templatingExtensions.pageTitle': 'Extensions de templating',
    'templateTypePicker.title': 'Catégories',
    'templateIntroPage.title': 'Gérer les modèles',
    'templateIntroPage.subtitle':
      'Modifiez, prévisualisez et essayez des modèles, des formulaires et des champs personnalisés',
    'templateFormPage.title': 'Éditeur de modèles',
    'templateFormPage.subtitle':
      'Modifiez, prévisualisez et essayez les formulaires des modèles',
    'templateCustomFieldPage.title': 'Explorateur de champs personnalisés',
    'templateCustomFieldPage.subtitle':
      'Modifiez, prévisualisez et essayez des champs personnalisés',
    'templateEditorPage.title': 'Éditeur de modèles',
    'templateEditorPage.subtitle':
      'Modifiez, prévisualisez et essayez des modèles et leurs formulaires',
    'templateEditorPage.dryRunResults.title': 'Résultats du dry run',
    'templateEditorPage.dryRunResultsList.title': 'Résultat {{resultId}}',
    'templateEditorPage.dryRunResultsList.deleteButtonTitle':
      'Supprimer le résultat',
    'templateEditorPage.dryRunResultsList.downloadButtonTitle':
      'Télécharger au format .zip',
    'templateEditorPage.dryRunResultsView.tab.output': 'Sortie',
    'templateEditorPage.dryRunResultsView.tab.log': 'Log',
    'templateEditorPage.dryRunResultsView.tab.files': 'Fichiers',
    'templateEditorPage.taskStatusStepper.skippedStepTitle': 'Ignorée',
    'templateEditorPage.customFieldExplorer.preview.title':
      'Spécification du modèle',
    'templateEditorPage.customFieldExplorer.fieldForm.title':
      'Options du champ',
    'templateEditorPage.customFieldExplorer.fieldForm.applyButtonTitle':
      'Appliquer',
    'templateEditorPage.customFieldExplorer.selectFieldLabel':
      "Choisir l'extension de champ personnalisé",
    'templateEditorPage.customFieldExplorer.fieldPreview.title':
      'Aperçu du champ',
    'templateEditorPage.templateEditorBrowser.closeConfirmMessage':
      'Êtes-vous sûr ? Les modifications non enregistrées seront perdues',
    'templateEditorPage.templateEditorBrowser.saveIconTooltip':
      'Enregistrer tous les fichiers',
    'templateEditorPage.templateEditorBrowser.reloadIconTooltip':
      'Recharger le répertoire',
    'templateEditorPage.templateEditorBrowser.closeIconTooltip':
      'Fermer le répertoire',
    'templateEditorPage.templateEditorIntro.title':
      'Commencez en choisissant une des options ci-dessous',
    'templateEditorPage.templateEditorIntro.loadLocal.title':
      'Charger un répertoire de modèle',
    'templateEditorPage.templateEditorIntro.loadLocal.description':
      "Chargez un répertoire de modèle local, vous permettant à la fois de modifier et d'essayer d'exécuter votre propre modèle.",
    'templateEditorPage.templateEditorIntro.loadLocal.unsupportedTooltip':
      'Pris en charge uniquement dans certains navigateurs basés sur Chromium avec la page chargée en HTTPS',
    'templateEditorPage.templateEditorIntro.createLocal.title':
      'Créer un nouveau modèle',
    'templateEditorPage.templateEditorIntro.createLocal.description':
      "Créez un répertoire de modèle local, vous permettant à la fois de modifier et d'essayer d'exécuter votre propre modèle.",
    'templateEditorPage.templateEditorIntro.createLocal.unsupportedTooltip':
      'Pris en charge uniquement dans certains navigateurs basés sur Chromium avec la page chargée en HTTPS',
    'templateEditorPage.templateEditorIntro.formEditor.title':
      'Bac à sable des formulaires de modèles',
    'templateEditorPage.templateEditorIntro.formEditor.description':
      "Prévisualisez et modifiez le formulaire d'un modèle, soit à partir d'un modèle d'exemple, soit en chargeant un modèle depuis le catalogue.",
    'templateEditorPage.templateEditorIntro.fieldExplorer.title':
      'Explorateur de champs personnalisés',
    'templateEditorPage.templateEditorIntro.fieldExplorer.description':
      'Consultez et expérimentez les extensions de champs personnalisés installées.',
    'templateEditorPage.templateEditorTextArea.saveIconTooltip':
      'Enregistrer le fichier',
    'templateEditorPage.templateEditorTextArea.refreshIconTooltip':
      'Recharger le fichier',
    'templateEditorPage.templateEditorTextArea.emptyStateParagraph':
      'Veuillez sélectionner une action dans le menu Fichier.',
    'templateEditorPage.templateFormPreviewer.title':
      'Charger un modèle existant',
    'templateListPage.title': 'Créer un nouveau composant',
    'templateListPage.subtitle':
      'Créez de nouveaux composants logiciels à partir des modèles standard de votre organisation',
    'templateListPage.pageTitle': 'Créer un nouveau composant',
    'templateListPage.templateGroups.defaultTitle': 'Modèles',
    'templateListPage.templateGroups.otherTitle': 'Autres modèles',
    'templateListPage.contentHeader.supportButtonTitle':
      'Créez de nouveaux composants logiciels à partir de modèles standard. Chaque modèle crée un type de composant différent (services, sites web, documentation, ...).',
    'templateListPage.contentHeader.registerExistingButtonTitle':
      'Enregistrer un composant existant',
    'templateListPage.additionalLinksForEntity.viewTechDocsTitle':
      'Voir la TechDocs',
    'templateWizardPage.title': 'Créer un nouveau composant',
    'templateWizardPage.subtitle':
      'Créez de nouveaux composants logiciels à partir des modèles standard de votre organisation',
    'templateWizardPage.pageTitle': 'Créer un nouveau composant',
    'templateWizardPage.pageContextMenu.editConfigurationTitle':
      'Modifier la configuration',
    'templateWizardPage.templateWithTitle':
      'Créer un nouveau {{templateTitle}}',
    'templateEditorToolbar.customFieldExplorerTooltip':
      'Explorateur de champs personnalisés',
    'templateEditorToolbar.installedActionsDocumentationTooltip':
      'Documentation des actions installées',
    'templateEditorToolbar.templatingExtensionsDocumentationTooltip':
      'Documentation des extensions de templating',
    'templateEditorToolbar.addToCatalogButton': 'Publier',
    'templateEditorToolbar.addToCatalogDialogTitle':
      'Publier les modifications',
    'templateEditorToolbar.addToCatalogDialogContent.stepsIntroduction':
      'Suivez les instructions ci-dessous pour créer ou mettre à jour un modèle :',
    'templateEditorToolbar.addToCatalogDialogContent.stepsListItems':
      "Enregistrez les fichiers du modèle dans un répertoire local\nCréez une pull request vers un dépôt git nouveau ou existant\nSi le modèle existe déjà, les modifications seront répercutées dans le catalogue logiciel une fois la pull request fusionnée\nMais si vous créez un nouveau modèle, suivez la documentation en lien ci-dessous pour enregistrer le nouveau dépôt de modèle dans le catalogue logiciel",
    'templateEditorToolbar.addToCatalogDialogActions.documentationUrl':
      'https://backstage.io/docs/features/software-templates/adding-templates/',
    'templateEditorToolbar.addToCatalogDialogActions.documentationButton':
      'Consulter la documentation',
    'templateEditorToolbarFileMenu.button': 'Fichier',
    'templateEditorToolbarFileMenu.options.openDirectory':
      'Ouvrir un répertoire de modèle',
    'templateEditorToolbarFileMenu.options.createDirectory':
      'Créer un répertoire de modèle',
    'templateEditorToolbarFileMenu.options.closeEditor':
      "Fermer l'éditeur de modèles",
    'templateEditorToolbarTemplatesMenu.button': 'Modèles',
  },
});
